import styled from "styled-components";

const SendedMessage = styled.div`
  width: auto;
  min-width: 60%;
  max-width: 70%;
  border-radius: 20px;
  background-color: #fbb700;
  color: #000000;
  align-self: flex-end;
  padding: 1%;
  margin-bottom: 1%;
`;

export default SendedMessage;
